<template v-if="pageRender">
    <div class="main-content">
        <section class="section">
          <div class="section-header">
            <h1>Pembiayaan Baru</h1>
          </div>
        <div class="section-body">
            <h2 class="section-title">Buat Pembiayaan</h2>
            <div class="row">
                <div class="col-12 col-md-4 col-lg-4">
                    <div class="card">
                        <div class="card-header">
                            <h4>Informasi Penerima</h4> <span @click="showAddNewKontak()" style="color:#8B008B;cursor:pointer">+ Tambah Kontak</span>
                        </div>
                        <div class="card-body" style="min-height:350px;">
                            <div class="form-group">
                                <label>Kontak</label>
                                <select id="kontak" class="form-control select2">
                                    <option v-for="(option,index) in supplierList" v-bind:key="index" :value="index" >{{ option.display_name}} </option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Alamat Supplier</label>
                                <textarea class="form-control" v-model="alamat" @focus="auto_alamat()"></textarea>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-4 col-lg-4">
                    <div class="card">
                        <div class="card-header">
                            <h4>Detail Pembiayaan</h4>
                        </div>
                        <div class="card-body" style="min-height:350px;">
                            <div class="form-group">
                                <label>Nomor Biaya</label>
                                <input type="text" v-model="nomor_pembiayaan" class="form-control">
                            </div>
                            <div class="form-group">
                                <label>Tanggal Transaksi</label>
                                <vc-date-picker v-model="tanggal_transaksi" :input-props='{class: "form-control",placeholder: "Masukkan tanggal transaksi",}'/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-4 col-lg-4">
                    <div class="card">
                        <div class="card-header">
                            <h4>Informasi Tambahan</h4>
                        </div>
                        <div class="card-body" style="min-height:350px;">
                            <div class="form-group mb-0">
                                <label>Deskripsi</label>
                                <textarea class="form-control" v-model="deskripsi" ></textarea>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="card">
                        <div class="card-header">
                            <h4>List Biaya</h4>
                        </div>
                        <div class="card-body">
                            <div class="table-responsive">
                                <table v-if="bodyRender" class="table table-striped table-md">
                                    <tr>
                                        <th>Akun</th>
                                        <th style="width:40%">Nama Biaya</th>
                                        <th>Jumlah</th>
                                        <th></th>
                                    </tr>
                                    <tr v-for="(data,index) in dataBiayaList" v-bind:key="index">
                                        <td>
                                            <div v-if="type == 'new'" class="form-group">
                                                <v-select :id="'akun_'+index" v-model="dataBiayaList[index].val" :reduce="text => text.value" :options="akunList" label="text" @input="insertValue(index)"></v-select>
                                            </div>
                                            <div v-else>
                                                {{ data.kode_akun }} - {{ data.nama_akun }}
                                            </div>
                                        </td>
                                        <td>
                                            <div v-if="type == 'new'" class="form-group">
                                                <input type="text" class="form-control" v-model="data.nama_item"> 
                                            </div>
                                            <div v-else>
                                                {{ data.nama_item }}
                                            </div>
                                        </td>
                                        <td>
                                            <div v-if="type == 'new'" class="form-group">
                                                <input type="number" class="form-control" v-model="data.total_biaya_item"> 
                                            </div>
                                            <div v-else>
                                                {{ data.total_biaya_item }}
                                            </div>
                                        </td>
                                        <td> <i v-if="type == 'new'" @click="deleteDataProduk(index)" style="font-size:18px;cursor:pointer;color:red;" class="fa fa-times"></i>  </td>
                                        
                                    </tr>
                                    <tr v-if="type == 'new'">
                                        <td>
                                            <button @click="addItem()" class="btn btn-primary">+ Tambah Data</button>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th style="text-align:right" colspan="2">Total Tagihan</th>
                                        <th>Rp. {{ currencyFormat(total_semua) }}</th>
                                    </tr>
                                    <tr v-if="status_bayar">
                                        <th style="text-align:right" colspan="2">Status Bayar</th>
                                        <th style="color:green"> Dibayar </th>
                                    </tr>
                                    <tr v-else>
                                        <th style="text-align:right" colspan="2"><input type="checkbox" id="jack" v-model="status"> Bayar Sekarang</th>
                                        <th>
                                            <div v-show="status" class="form-group">
                                                <select id="akun_bayar" class="form-control select2">
                                                    <option value="">__ - --- Pilih Akun Pembayaran --- - __</option>
                                                    <option v-for="(option, ind) in akunBayarList" v-bind:key="ind" :value="ind" >{{ option.kode_akun }} - {{ option.nama_akun }} </option>
                                                </select>
                                            </div>
                                        </th>
                                    </tr>
                                    <tr v-if="status && !status_bayar">
                                        <th style="text-align:right" colspan="2">Tanggal Pembayaran</th>
                                        <th>
                                            <vc-date-picker v-model="tanggal_pembayaran" :input-props='{class: "form-control",placeholder: "Masukkan tanggal pembayaran",style:"text-align:center;vertical-align:middle"}'/>
                                        </th>
                                    </tr>
                                </table>
                            </div>
                            
                        </div>
                    </div>
                </div>
                <div class="col-12 text-center">
                    <button @click="goBack()" class="btn btn-danger"><i class="fas fa-times"></i> Batal</button>
                    <button v-if="type == 'new'" @click="submit('normal')" class="btn btn-success">Buat Pembiayaan</button>
                    <button v-if="type == 'new'" @click="submit('next')" class="btn btn-primary">Buat & Baru</button>
                    <button v-if="type == 'edit'" @click="submit('edit')" class="btn btn-outline-success">Update Pembiayaan</button>
                </div>
            </div>
            
        </div>
        </section>
        <div class="modal show"  v-if="showAddKontak">
            <div class="modal-content">
                <add-kontak></add-kontak>
            </div>
        </div>
    </div>
</template>
<style>
.vs__dropdown-toggle {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    display: flex;
    padding: 7px 4px 7px 4px;
    background: none;
    border: 1px solid #e4e6fc;
    border-radius: 4px;
    white-space: normal;
    min-width: 360px;
}
.vs__actions {
    padding: 0px 6px 0 3px;
}
.vs__clear {
    display:none;
}
.vs__dropdown-menu {
    background-color: white;
    border: 1px solid #aaa;
    border-radius: 4px;
    box-sizing: border-box;
    display: block;
    position: absolute;
    z-index: 3000;
    max-height: 120px !important;
}

.modal {
  padding-top: 5%; /* Location of the box */
  padding-bottom: 5%;
  background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
}

.modal-content {
  position: relative;
  background-color: #fefefe;
  margin: auto;
  padding: 0;
  border: 1px solid #888;
  width: 80%;
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2),0 6px 20px 0 rgba(0,0,0,0.19);
  -webkit-animation-name: animatetop;
  -webkit-animation-duration: 0.4s;
  animation-name: animatetop;
  animation-duration: 0.4s
}

.show {
    display : block !important;
}

.custom-select2 {
    width: -webkit-fill-available;
}

@-webkit-keyframes animatetop {
  from {top:-300px; opacity:0} 
  to {top:0; opacity:1}
}

@keyframes animatetop {
  from {top:-300px; opacity:0}
  to {top:0; opacity:1}
}


</style>

<script>
import Vue from 'vue'
import {IMaskDirective} from 'vue-imask';
import vSelect from 'vue-select'
import VCalendar from 'v-calendar';
import AddKontak from '../kontak/KontakBaruLite.vue'
import VModal from 'vue-js-modal'
import vueXlsxTable from 'vue-xlsx-table'
import housecall from 'housecall'

Vue.component('v-select', vSelect)

Vue.use(VCalendar, {
  componentPrefix: 'vc',
  locales: {
    'pt-PT': {
      firstDayOfWeek: 1,
      masks: {
        L: 'YYYY-MM-DD',
        input : 'YYYY-MM-DD'
      }
    }
  }
});

Vue.use(VModal)
Vue.use(vueXlsxTable, {rABS: false})

var future = new Date();
future.setDate(future.getDate() + 30);

var queue = housecall({ concurrency: 1, cooldown: 300 });

export default {
    data() {
        return {
            type : 'new',
            id_pembiayaan : '',
            pembiayaanDetail : [],
            nomor_pembiayaan : '',
            auto : '',
            tanggal_transaksi : new Date(),
            deskripsi : '',
            akunList : [],
            akunBayarList : [],
            akun_bayar : '',
            supplierList : [],
            kontak: '',
            alamat : '',
            dataBiayaList : [],
            mask: {
                mask: Number,
                thousandsSeparator: '.',
                normalizeZeros: false,
            },
            vcattrs: [
                {
                    key: 'today',
                    highlight: true,
                    dates: new Date(),
                },
            ],
            url : '',
            showAddKontak : false,
            siteUrl : window.location.href.substr(0, window.location.href.indexOf('#')),
            bodyRender : true,
            pageRender : true,
            status : false,
            tanggal_pembayaran : new Date(),
            status_bayar : false,
        }
    },
    mounted() {
        if(this.$route.params.id_pembiayaan != null){
            this.type = 'edit'
        }
        this.init();
        window.$(document).ready(function(){
            setTimeout(function(){ 
                $("#kontak").select2();
            }, 100);
        });

        window.$(document).ready(function(){
            setTimeout(function(){ 
                $("#akun_bayar").select2({
                    dropdownCssClass: "custom-select2"
                });
            }, 100);
        });
    },
    methods: {
        init: function() {
            var que = 0;
            this.$root.is_loading = !this.$root.is_loading;
            var url = window.location.href.substring(window.location.href.lastIndexOf('/') + 1);

            //get akun list
            this.$http.post("Finance/getAkunListForBiaya").then(result => {
                if(result.data.code == '00'){
                    console.log('akun list empty')
                }else {
                    this.akunList = result.data.detail
                    que = 1
                    if(que == 1 && this.type == 'edit'){
                        this.getPembiayaanDetail()
                    }
                    else
                    {
                        this.addItem()
                    }
                }
                this.$root.is_loading = false;
            })

            //get supplier list
            this.$http.post("Kontak/getKontakList/supplier").then(result => {
                if(result.data.code == '00'){
                    console.log('kontak supplier empty')
                }else {
                    this.supplierList = result.data.detail
                }
            })

            // get coa/akun pembayaran
			this.$http.post("Datalist/getCoa").then(result => {
			    if(result.data.code == '00') {
                    alert('failed get coa')
                }
                else {
                    this.akunBayarList = this.filterArr(result.data.detail,'id_kategori','3');
                    // this.akunJualList = this.filterArr(this.akunList,'id_kategori','13')
                }
			}, error => {
				console.log('gk ok')
				context.errors = errors;
            });
        },
        getPembiayaanDetail: function() {
            // get Pembiayaan detail
            this.$root.is_loading = true
            if(this.$route.params.id_pembiayaan != null) {
                this.type = 'edit'
                this.id_pembiayaan = this.$route.params.id_pembiayaan
                this.$http.post("Finance/getPembiayaanDetail/"+this.id_pembiayaan).then(result => {
                    if(result.data.code == '00') {
                        alert('failed get Detail')
                    }
                    else {
                        this.pembiayaanDetail = result.data.detail
                
                        this.alamat = this.pembiayaanDetail.detail.alamat_kontak
                        this.nomor_pembiayaan = this.pembiayaanDetail.detail.nomor_pembiayaan
                        this.deskripsi = this.pembiayaanDetail.detail.deskripsi
                        this.tanggal_transaksi = new Date(this.pembiayaanDetail.detail.tanggal_transaksi)
                        this.kontak = this.pembiayaanDetail.detail.id_kontak
                        this.status_bayar = this.pembiayaanDetail.detail.status == 1 ? true : false
                        this.status = this.pembiayaanDetail.detail.status == 1 ? true : false
                        let that = this
                        this.supplierList.forEach(function(item,index){
                            if(item.id_kontak == that.kontak){
                                that.kontak = index
                                $("#kontak").val(that.kontak).trigger('change');
                                return that.kontak
                            }
                        })
                        
                        if(this.pembiayaanDetail.biayaList.length > 0) {
                            this.dataBiayaList = this.pembiayaanDetail.biayaList
                        }
                    }
                }, error => {
                    console.log('gk ok')
                    context.errors = errors;
                });
            }
        },
        auto_alamat: function() {
            var i = $("#kontak").select2('val')
            this.kontak = this.supplierList[i].id_kontak
            if(this.alamat == ''){
                this.alamat = this.supplierList[i].alamat
            }
            if(this.email == ''){
                this.email  = this.supplierList[i].email
            }
        },
        submit: function(type) {
           
            if(this.kontak == '') {
                var i = $("#kontak").select2('val')
                if(i == '' || i == null){
                    this.$parent.toastr = {
                        title : 'Warning',
                        message: 'Kontak harus diisi !',
                        type : 'warning'
                    }
                    return false
                }else{
                    this.kontak = this.supplierList[i].id_kontak
                }
            }else {
                var i = $("#kontak").select2('val')
                this.kontak = this.supplierList[i].id_kontak
            }

            if(this.nomor_pembiayaan == '')
            {
                this.$parent.toastr = {
                    title : 'Warning',
                    message: 'Nomor Pembiayaan harus diisi !',
                    type : 'warning'
                }
                return false
            }

            if(!confirm('Pastikan semua data sudah sesuai !')){
                return false
            }

            var formsub = new FormData();
            var objThis = this;
            formsub.append('type',this.type);
            formsub.append('id_kontak',this.kontak);
            formsub.append('alamat',this.alamat);
            formsub.append('nomor_pembiayaan',this.nomor_pembiayaan);
            formsub.append('deskripsi',this.deskripsi);
            formsub.append('tanggal_transaksi',this.formatDate(this.tanggal_transaksi))

            if(this.type == 'edit') {
                formsub.append('id_pembiayaan',this.id_pembiayaan)
            }

            $.map(objThis.dataBiayaList, function(value,index){
                if(value.id_coa == ''){
                    
                }else{
                    formsub.append('dataBiaya['+index+'][id_coa]', value.id_coa);
                    formsub.append('dataBiaya['+index+'][nama_item]', value.nama_item);
                    formsub.append('dataBiaya['+index+'][total_biaya_item]', value.total_biaya_item);
                }
            });

            formsub.append('status',this.status ? 1 : 0);

            if(this.status && !this.status_bayar)
            {
                var b = $("#akun_bayar").select2('val')
                this.akun_bayar = this.akunBayarList[b].id_coa
                console.log(this.akun_bayar)
                if(b == '' || b == null){
                    this.$parent.toastr = {
                        title : 'Warning',
                        message: 'Silahkan pilih akun untuk membayar !',
                        type : 'warning'
                    }
                }
                formsub.append('akun_bayar',this.akun_bayar);
                formsub.append('tanggal_pembayaran', this.formatDate(this.tanggal_pembayaran))
            }
            else
            {
                formsub.append('status_bayar',1);
            }

            formsub.append('total_biaya',this.total_semua);

            this.$http.post("Finance/insertPembiayaan", formsub).then(result => {
                console.log(result);
                if(result.data.code == '01') {
                    this.$parent.toastr = {
                        title : 'Success',
                        message: 'Pembiayaan berhasil diinput !',
                        type : 'success'
                    }
                    if(type == 'normal'){
                        this.$router.replace({ path : '/pembiayaan/list' })
                    }else if(type == 'next') {
                        this.$parent.reRendering();                                      
                    }else {
                        this.$router.replace({ path : window.localStorage.getItem('last_route') })
                    }
                }
                else {
                    this.$parent.toastr = {
                        title : 'Error',
                        message: 'Transaksi gagal diinput !',
                        type : 'error'
                    }                    
                }
			}, error => {
				console.log('gk ok')
					context.errors = errors;
			});
        },
        filterArr: function(array,prop,value) {
            var filtered = [];
            for(var i = 0; i < array.length; i++){
                if(array[i][prop] == value){
                    filtered.push(array[i])
                }
            }    
            return filtered;
        },
        currencyFormat: function(val){
            return this.$parent.currencyFormat(val)
        },
        addItem: function() {
			this.dataBiayaList.push({
                    id_coa: '',
                    nama_item: '',
                    total_biaya: 0
			});
        },
        insertValue(index){
            this.dataBiayaList[index].id_coa = this.dataBiayaList[index].val
        },
        countSatuan(index){
            this.dataProdukList[index].harga_satuan = this.dataProdukList[index].jumlah_harga / this.dataProdukList[index].qty;
        },
        MoneyCallback(x) {
            return x.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        formatDate(date) {
            var d = new Date(date),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2) month = '0' + month;
            if (day.length < 2) day = '0' + day;

            return [year, month, day].join('-');
        },
        goBack() {
            this.$router.replace({ path : window.localStorage.getItem('last_route') })
            var $path = window.location.href.split('/');
            this.isActive = this.$route.path;
        },
        showAddNewKontak: function() {
            console.log('masuk gan')
            this.showAddKontak = true;
        },
        closeAddNewKontak: function() {
            //get supplier list
            this.showAddKontak = false;
            this.$http.post("Kontak/getKontakList/supplier").then(result => {
                if(result.data.code == '00'){
                    console.log('bahan list empty')
                }else {
                    this.supplierList = result.data.detail
                }
            })
        },
        deleteDataProduk: function(index) {
            console.log(index);
            this.$parent.toastr = {
                title : 'Success',
                message: 'Produk '+this.dataProdukList[index].kode_produk+' | '+this.dataProdukList[index].nama_produk+' berhasil dihapus !',
                type : 'success'
            }
            this.$nextTick(function(){
                this.dataProdukList.splice(index, 1);
                this.bodyRender = false
                this.$nextTick(function(){
                    this.bodyRender = true
                })
            })
        },
        finishGetDetail: function() {
            this.$root.is_loading = false;
            this.bodyRender = false
            this.$nextTick(function(){
                this.bodyRender = true
            })
            let that = this
            this.supplierList.forEach(function(item,index){
                if(item.id_kontak == that.supplier){
                    that.supplier = index
                    $("#supplier").val(that.supplier).trigger('change');
                    return that.supplier
                }
            })
        },
        oppositeFilterArr: function(array,prop,value) {
            var filtered = [];
            for(var i = 0; i < array.length; i++){
                if(array[i][prop] != value){
                    filtered.push(array[i])
                }
            }    
            return filtered;
        },
    },
    directives: {
      imask: IMaskDirective
    },
    components: {
        AddKontak
    },
    watch: {
        
    },
    computed: {
        // total_tagihan : function(){
        //     var totals = 0;
        //     this.dataProdukList.forEach(function(item, index){
        //         totals = parseInt(item.jumlah_harga) + totals
        //     })
        //     return totals
        // },
        total_semua : function() {
            var totals = 0;
            this.dataBiayaList.forEach(function(item, index){
                totals = parseFloat(item.total_biaya_item) + totals
            })
            return totals
        }
    },
}
</script>


// WEBPACK FOOTER //
// src/components/pembiayaan/BiayaForm.vue